/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'betterez': {
    width: 16,
    height: 16,
    viewBox: '11 4.936331 54.780535 54.780538',
    data: '<path pid="0" d="M 65.780535,4.936331 H 11 V 23.19651 H 34.624752 L 11,46.82126 23.895606,59.716869 47.520358,36.092116 V 59.716869 H 65.780535 Z M 63.09825,7.618617 V 57.034583 H 50.202644 V 36.092116 29.592731 L 45.560225,34.235148 23.895606,55.899765 14.8171,46.82126 36.584883,25.053477 41.227302,20.411058 H 34.727916 13.682286 V 7.618617 Z"/>'
  }
})
